import { makeStyles } from '@material-ui/core/styles';
import { vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  centerMessaging: {
    justifyContent: 'flex-start',
    zIndex: 10,
  },
  exitButtonContainer: {
    justifyContent: 'center',
    paddingBottom: '1vh',
  },
  exitButton: {
    lineHeight: '1.14',
    letterSpacing: '0.05rem',
    fontWeight: 500,
    fontSize: vh(2.08),
    marginRight: vw(1),
    '&.Mui-disabled': {
      color: themeColor.rollingStone,
    },
  },
  leftHandedContent: {
    paddingBottom: '1vh',
    justifyContent: 'flex-start',
    alignContent: 'flex-end',
  },
  paymentInfo: {
    fontSize: vh(3.125),
    fontWeight: 400,
    paddingBottom: '2vh',
  },
  rightHandedContent: {
    paddingBottom: '1vh',
    justifyContent: 'center',
    alignContent: 'center',
  },
  textAlignCenter: {
    textAlign: 'center',
    height: 'fit-content',
    width: '100%',
  },
  total: {
    fontSize: vh(3.125),
    fontWeight: 500,
    letterSpacing: '0.02rem',
    paddingTop: '0.5vh',
  },
  totalLabel: {
    fontSize: vh(1.8),
    color: theme.palette.info.dark,
    fontWeight: 500,
    paddingTop: '1vh',
  },
  typographytitle: {
    color: themeColor.defaultDarkTextColor,
    letterSpacing: 0.25,
    fontSize: '3.9vh',
  },
  viewContainer: {
    width: '0',
    backgroundColor: themeColor.lightBackground,
  },
  redeemContainer: {
    background: themeColor.lightBackground,
  },
  viewHeader: {
    marginLeft: '2%',
    marginRight: '2%',
    marginTop: '2%',
  },
  redeemRewardBar: {
    color: themeColor.primaryColor,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `10px solid ${theme.palette.primary.main}`,
    width: '66px',
    marginTop: '5vh',
    marginBottom: '5vh',
  },
  redeemInfoText: {
    color: '#5D6B72',
  },
  redeemMarginTop: {
    marginTop: '2.5vh',
  },
  redeemMarginBottom: {
    marginBottom: '1.5vh',
  },
  w45: {
    width: '45%',
  },
}));
